"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupSignupPlanSelected = exports.setupSignupSelectPlanButtonClicked = exports.setupSignupButonClicked = exports.setupUgradeButtonClicked = exports.setupCancelButtonTracker = exports.setupUpgradePlansPageViewed = exports.setupSignupSelectPlanPageViewed = exports.setupSignupPageViewTracker = exports.createTracker = void 0;
const tracker_1 = __importDefault(require("./tracker"));
function createTracker(apiKey, userId) {
    if (apiKey === null || apiKey === undefined || apiKey === "") {
        return null;
    }
    return new tracker_1.default(apiKey, userId);
}
exports.createTracker = createTracker;
function setupSignupPageViewTracker(tracker) {
    if (window.location.href.indexOf("/signup") === -1) {
        return;
    }
    let flowPath = tracker.formatter.formatSignupFlowPath();
    tracker.trackSignupPageViewed(flowPath);
}
exports.setupSignupPageViewTracker = setupSignupPageViewTracker;
function setupSignupSelectPlanPageViewed(tracker) {
    if (!window.location.href.includes("/select-plan")) {
        return;
    }
    const planGroupData = tracker.formatter.getCurrentPlanGroupData();
    if (planGroupData === null) {
        console.log("No plan group data found");
        return;
    }
    tracker.trackSignupSelectPlanPageViewed(planGroupData.id, planGroupData.name);
}
exports.setupSignupSelectPlanPageViewed = setupSignupSelectPlanPageViewed;
function setupUpgradePlansPageViewed(tracker) {
    if (!window.location.href.includes("/account/plan")) {
        return;
    }
    const planGroupData = tracker.formatter.getCurrentPlanGroupData();
    if (planGroupData === null) {
        console.log("No plan group data found");
        return;
    }
    tracker.trackUpgradePlansPageViewed(planGroupData.id, planGroupData.name);
}
exports.setupUpgradePlansPageViewed = setupUpgradePlansPageViewed;
function setupCancelButtonTracker(tracker) {
    let cancelButton = $(".account .accountunsubscribe");
    if (cancelButton.length <= 0) {
        return;
    }
    cancelButton.on("click", function () {
        tracker.trackCancelButtonClicked();
    });
}
exports.setupCancelButtonTracker = setupCancelButtonTracker;
// export function setupSignupPricingPageViewed(tracker: Tracker): void {
//   if (window.location.href !== "/plans-and-pricing") {
//     return;
//   }
//   const accountGuid = $("#account-guid");
//   let planGroup = "";
//   if (typeof accountGuid !== "undefined" && accountGuid.length > 0) {
//     planGroup =
//       accountGuid.attr("data-account-plan-type") +
//       "-" +
//       accountGuid.attr("data-account-plan-name");
//   }
//   tracker.trackSignupPricingPageViewed(planGroup);
// }
function setupUgradeButtonClicked(tracker) {
    $(".account .ctn-t5 .upgrade").on("click", function () {
        tracker.trackUpgradeButtonClicked("account-page", "");
    });
    $(".account .ctn-t5 .change").on("click", function () {
        tracker.trackUpgradeButtonClicked("account-page", "");
    });
    $(".account .ctn-t5 .renew").on("click", function () {
        tracker.trackUpgradeButtonClicked("account-page", "");
    });
    $(".notibanner-dot1 .upg").on("click", function () {
        tracker.trackUpgradeButtonClicked("banner", "");
    });
    $(".account .ussta-t1 .upgrade").on("click", function () {
        tracker.trackUpgradeButtonClicked("upgrade-button", "");
    });
    $(".upgbox-t1 .its .upgrade").on("click", function () {
        tracker.trackUpgradeButtonClicked("upgrade-button", "");
    });
    $(".mo-upg-t1 a").on("click", function () {
        tracker.trackUpgradeButtonClicked("upgrade-link", "");
    });
    $(".noti-upgrade a").on("click", function () {
        tracker.trackUpgradeButtonClicked("upgrade-link", "");
    });
}
exports.setupUgradeButtonClicked = setupUgradeButtonClicked;
function setupSignupButonClicked(tracker) {
    $(".top .signup").on("click", function () {
        tracker.trackSignupButtonClicked("website-header");
    });
    // Signup box
    $(".nws-fr .btn").on("click", function () {
        tracker.trackSignupButtonClicked("email-signup-box");
    });
    // "Create your event" frontpage
    $(".bnr-cnt .btn-fs-bg").on("click", function () {
        tracker.trackSignupButtonClicked("solution-hero");
    });
    // Signup -> https://www.addevent.com/plans-and-pricing
    $(".prib.signedout .act .signup").on("click", function () {
        tracker.trackSignupButtonClicked("pricing-plan");
    });
    $(".prib.signedout .act .entsignup").on("click", function () {
        tracker.trackSignupButtonClicked("pricing-enterprise");
    });
    // Signup -> https://www.addevent.com/plans-and-pricing/details
    $(".vid .vid-cnt .vid-block .btn").on("click", function () {
        tracker.trackSignupButtonClicked("pricing-details");
    });
    // Signup -> on solution pages like -> https://www.addevent.com/solutions/collect-rsvp-events
    $(".bnr .bnr-cnt .s1 .btn-plc .btn").on("click", function () {
        tracker.trackSignupButtonClicked("solution-hero");
    });
    $(".cal .cal-cnt .bottom .btn-place .btn").on("click", function () {
        tracker.trackSignupButtonClicked("solution-middle");
    });
    $(".txtimg-grid .item .link .btn").on("click", function () {
        tracker.trackSignupButtonClicked("solution-middle");
    });
    // Documentation - "Add to Calendar" button page -> https://www.addevent.com/documentation/add-to-calendar-button
    $(".sgnbrk-t2 .bts .bt1").on("click", function () {
        tracker.trackSignupButtonClicked("solution-hero");
    });
    // Add to Calendar button page -> https://www.addevent.com/add-to-calendar-button
    $(".sec1 .ma .lft .pad .bt .btn").on("click", function () {
        tracker.trackSignupButtonClicked("solution-hero");
    });
    $(".sec3 .li .btn").on("click", function () {
        tracker.trackSignupButtonClicked("solution-middle");
    });
    // Sign in page -> clicking "Sign up"
    $(".usica-t1 .auto .pad .inp-t9 a").on("click", function () {
        tracker.trackSignupButtonClicked("signin-page");
    });
    // MailChimp - app - sign in/sign up page
    $(".wrap .box .hx-t2 .btn").on("click", function () {
        tracker.trackSignupButtonClicked("signin-page");
    });
}
exports.setupSignupButonClicked = setupSignupButonClicked;
function setupSignupSelectPlanButtonClicked(tracker) {
    $("#signupplans").on("click", function () {
        const planData = tracker.formatter.getSignupPlanData();
        if (planData !== null) {
            tracker.trackSignupSelectPlanButtonClicked(planData.getPlanId(), planData.plan_type_name, planData.payment_schedule);
        }
    });
    $("#hobbyplanform").on("click", function () {
        const planData = tracker.formatter.getSignupPlanData();
        if (planData !== null) {
            tracker.trackSignupSelectPlanButtonClicked(planData.getPlanId(), planData.plan_type_name, planData.payment_schedule);
        }
    });
    $("#enterpriseplanform").on("click", function () {
        const planData = tracker.formatter.getSignupPlanData();
        if (planData !== null) {
            tracker.trackSignupSelectPlanButtonClicked(planData.getPlanId(), planData.plan_type_name, planData.payment_schedule);
        }
    });
}
exports.setupSignupSelectPlanButtonClicked = setupSignupSelectPlanButtonClicked;
function setupSignupPlanSelected(tracker) {
    return;
    // $("#hobbyplanform .submit").on("click", function () {
    //   tracker.trackSignupPlanSelected("hobby");
    // });
    // $("#enterpriseplanform .submit").on("click", function () {
    //   tracker.trackSignupPlanSelected("enterprise");
    // });
    // $("#creditcardform .submit").on("click", function () {
    //   tracker.trackSignupPlanSelected(
    //     tracker.formatter.formatSignupPlanSelected()
    //   );
    // });
}
exports.setupSignupPlanSelected = setupSignupPlanSelected;
